import React, { Fragment, useEffect, useState } from 'react';
import { Card, Col, Container, Row, Button, Form } from 'react-bootstrap';
import IconComponent from '../Icons';
import { ButtonCard, CardTela, SpanCard } from './styles';
import { verticalAlignment } from 'mammoth/mammoth.browser';

function TrelloBoard({ columns, columnsAditional, columnsFilter = columns, data, setData, titleLista, buttons, mdColCard=4, isGridOrigin=false, mdColCardOpen=4, exibeList=true, disabledForm = false, tamanhoCard='90lvh', HabilitaSelecao=false, handleAprovarTodos, handleReprovarTodos, HabilitaBuscar=false, AbreBox, FechaBox }) {
    const [uniqueLists, setUniqueLists] = useState([]);
    const [expandedCards, setExpandedCards] = useState({});
    const [searchTerm, setSearchTerm] = useState("");
    
    const handleToggleExpand = (itemId) => {
        setExpandedCards((prevExpandedCards) => ({
            ...prevExpandedCards,
            [itemId]: !prevExpandedCards[itemId],
        }));
    };

    const handleSelectItem = (itemId, isSelected, data, setData) => {
        const updatedData = data.map((item) =>
            item.item === itemId ? { ...item, isSelected } : item
        );
        
        setData(updatedData); // Atualiza o estado no componente pai
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value.toUpperCase());
    };

    useEffect(() => {
        let uniqueData = Array.from(new Set(data.map((item) => item.item)))
        setUniqueLists(uniqueData);
        
        if (data.length > 0){
            const possuiShow = data.some(obj => 'show' in obj);
            if (typeof setData === 'function' && searchTerm === "" && !possuiShow){
                const newData = [...data];
    
                const updatedData = newData.map((item) => {
                    return { ...item, show: true }; // Atualiza a propriedade show
                });
            
                setData([...updatedData]); // Atualiza o estado com os novos valores
            }
        }
    }, [data]);

    useEffect(() => {
        if (typeof setData === 'function'){ 
            const newData = [...data]

            const updatedData = newData.map((item) => {
                const matches = columnsFilter.some((col) => {
                    const value = getColumnValue(item, col.accessor);//Ajustar aqui para obter o value caso tenha render
                    
                    return value && value.toString().toUpperCase().includes(searchTerm.toUpperCase());
                });
        
                return { ...item, show: matches }; // Atualiza a propriedade show
            });
        
            setData([...updatedData]); // Atualiza o estado com os novos valores
        }
    }, [searchTerm]);

    return (
        <Container fluid>
            {HabilitaBuscar && (
                <Row className="mb-2 justify-content-end">
                    <Col md={3}>
                        <Form.Control
                            type="text"
                            placeholder="Buscar..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                    </Col>
                </Row>
            )}
            { HabilitaSelecao && data.filter((item) => item.isSelected).length > 0 && ( // && (handleAprovarTodos || handleReprovarTodos) 
                <Row>
                    <Col md="8"></Col>
                    <Col md="2">
                        <Button className="w-100" variant='success' onClick={handleAprovarTodos}>Aprovar Todos</Button>
                    </Col>
                    <Col md="2">
                        <Button className="w-100" variant='danger' onClick={handleReprovarTodos}>Reprovar Todos</Button>
                    </Col>
                </Row>
            )}
            <Row>
                { uniqueLists.length > 0 && uniqueLists.map((listTitle) => (
                    <Fragment key={`list-${listTitle}`}>
                        {data.filter((item) => item.item === listTitle)
                        .map((item) => {
                            if ((HabilitaBuscar && item.show == true) || !HabilitaBuscar ){
                            // if ((HabilitaBuscar && item.show) || typeof setData === 'undefined' || !HabilitaBuscar){                            
                                const isExpanded = expandedCards[item.item] || isGridOrigin;
                                let row = {
                                    ...item, 
                                    original: {...item},
                                    values: {...item},
                                };

                                return (
                                    <Col key={`col-main-${listTitle}`} xs={12} md={isExpanded ? mdColCardOpen: mdColCard} className="d-flex align-items-stretch">
                                        <CardTela key={`card-tela-${item.item}`} $isOpen={isExpanded} tamanho={tamanhoCard}>
                                            <Card.Header className="d-flex justify-content-between align-items-center">
                                                {HabilitaSelecao && (
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={item.isSelected || false}
                                                        onChange={(e) =>
                                                            handleSelectItem(item.item, e.target.checked, data, setData)
                                                        }
                                                    />
                                                )}
                                                { titleLista && (
                                                    <span>{titleLista} {exibeList ? listTitle: ''}</span>
                                                )}
                                                {columnsAditional && columnsAditional.length > 0 && (
                                                    <Button
                                                        variant="link"
                                                        onClick={() => handleToggleExpand(item.item)}
                                                        className="d-flex justify-content-end align-items-end"
                                                    >
                                                    {isExpanded ? '- Detalhes' : '+ Detalhes'}
                                                    </Button>
                                                )}
                                            </Card.Header>
                                            <Card.Body>
                                                <div>
                                                    {columns.map((column,idx) => {
                                                        let itemReturn = {
                                                            ...item, 
                                                            value: getColumnValue(item, column.accessor),
                                                            row: { original: {...item} },
                                                            accessor: column.accessor,
                                                            Header: column.Header,
                                                            isExpanded: isExpanded,
                                                            index: idx
                                                        };

                                                        return (
                                                            <div key={`card-body-${column.Header}-${item.item}`} style={{ display: "contents"}}>
                                                                {column.render 
                                                                    ? column.render(itemReturn, column.accessor, column.Header, data, setData, disabledForm, AbreBox, FechaBox)
                                                                    :   <div style={{ marginBottom: '8px' }}>
                                                                            <strong>{column.Header}: </strong>
                                                                            {getColumnValue(itemReturn, column.accessor)}
                                                                        </div> 
                                                                }
                                                            </div>
                                                        )
                                                    })}

                                                    {isExpanded && !item.ITENS && columnsAditional.map((column, idx) => {
                                                        let itemReturn = {
                                                            ...item, 
                                                            value: getColumnValue(item, column.accessor),
                                                            row: { original: {...item} },
                                                            accessor: column.accessor,
                                                            Header: column.Header,
                                                            isExpanded: isExpanded,
                                                            index: idx
                                                        };
                                                        
                                                        return (
                                                            <div key={`card-body-additional-${column.Header}-${item.item}`} style={{ display: "contents"}}>
                                                                {column.render 
                                                                    ? column.render(itemReturn, column.accessor, column.Header, data, setData, disabledForm, AbreBox, FechaBox)
                                                                    :   <div style={{ marginBottom: '8px' }}>
                                                                            <strong>{column.Header}: </strong>
                                                                            {getColumnValue(itemReturn, column.accessor)}
                                                                        </div> 
                                                                }
                                                            </div>
                                                        )
                                                    })}

                                                    {isExpanded && item.ITENS && columnsAditional.map((column) => {
                                                        return (
                                                            item.ITENS.map( (itens,idx) => {
                                                                let itemReturn = {
                                                                    ...item, 
                                                                    ...itens,
                                                                    value: getColumnValue(item, column.accessor),
                                                                    row: { original: {...item, ...itens} },
                                                                    accessor: column.accessor,
                                                                    Header: column.Header,
                                                                    index: idx
                                                                };
                                                                
                                                                return (
                                                                    <div key={`card-body-details-${column.Header}-${item.item}`} style={{ display: "contents"}}>
                                                                        {column.render 
                                                                            ? column.render(itemReturn, column.accessor, column.Header, data, setData, disabledForm, AbreBox, FechaBox)
                                                                            :   <div style={{ marginBottom: '8px' }}>
                                                                                    <strong>{column.Header}: </strong>
                                                                                    {getColumnValue(itemReturn, column.accessor)}
                                                                                </div> 
                                                                        }
                                                                    </div>
                                                                )
                                                            })
                                                        )
                                                    })}
                                                </div>
                                            </Card.Body>
                                            {buttons && buttons.length > 0 && (
                                                <Card.Footer className="d-flex justify-content-end">
                                                    {buttons.map((button, index) => {
                                                        const shouldRenderButton = !button.regraExclude || (button.regraExclude && !eval(button.regraExclude));
                                                        
                                                        return shouldRenderButton ? (
                                                            <ButtonCard 
                                                                key={`button-card-${button.label}-${row.item}`} // Adding a unique key prop for each button
                                                                onClick={() => button.action(row, data, setData)} 
                                                                variant={button.style ? button.style : "info"}
                                                            >
                                                                <IconComponent icon={button.icone} />
                                                                <SpanCard>{button.label}</SpanCard>
                                                            </ButtonCard>
                                                        ) : null;
                                                    })}
                                                </Card.Footer>
                                            )}
                                        </CardTela>
                                    </Col>
                                );
                            }
                        })}
                    </Fragment>
                ))}
            </Row>
        </Container>
    );

    // Função auxiliar para obter o valor da coluna aninhada
    function getColumnValue(item, accessor) {
        const parts = accessor.split('.');
        let value = item;
        
        for (const part of parts) {
            if (value && value.hasOwnProperty(part)) {
                value = value[part];
            } else {
                value = undefined;
                break;
            }
        }

        return value;
    }
}

export default TrelloBoard;
